import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const c=t("morocco",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#D20023" />
            <path
                d="M14.3504 15.7357L11.9994 14.0277L9.64844 15.7357L10.5464 12.972L8.19531 11.2638H11.1014L11.9994 8.5L12.8974 11.2638L15.8035 11.2638L13.4524 12.972L14.3504 15.7357ZM10.8699 13.207L10.3717 14.7402L11.6759 13.7927L10.8699 13.207ZM12.3229 13.7927L13.6271 14.7402L13.1289 13.207L12.3229 13.7926V13.7927ZM10.9934 12.8268L11.9994 13.5576L13.0054 12.8268L12.6211 11.6441H11.3777L10.9934 12.8268H10.9934ZM13.021 11.6441L13.3289 12.5918L14.6332 11.6441H13.021ZM9.36566 11.6441L10.67 12.5918L10.9779 11.6441H9.36566ZM11.5013 11.2638H12.4976L11.9994 9.73062L11.5013 11.2638Z"
                fill="#006233" />
        </svg>
    `),r=t("morocco_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66516)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 0.5L30 0.5L30 24.5L-6 24.5L-6 0.5Z"
                    fill="#D20023" />
                <path
                    d="M15.5256 17.3536L11.9991 14.7915L8.47266 17.3536L9.81963 13.208L6.29297 10.6458H10.6521L11.9991 6.5L13.3462 10.6458L17.7053 10.6458L14.1787 13.208L15.5256 17.3536ZM10.3048 13.5605L9.55758 15.8603L11.5139 14.439L10.3048 13.5605ZM12.4843 14.439L14.4407 15.8603L13.6934 13.5605L12.4843 14.4389V14.439ZM10.4901 12.9902L11.9991 14.0865L13.508 12.9902L12.9317 11.2162H11.0665L10.4901 12.9902H10.4901ZM13.5315 11.2162L13.9933 12.6376L15.9498 11.2162L13.5315 11.2162ZM8.0485 11.2162L10.0049 12.6376L10.4668 11.2162H8.0485ZM11.2519 10.6458H12.7464L11.9991 8.34592L11.2519 10.6458Z"
                    fill="#006233" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66516">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{c as Morocco,r as MoroccoRounded};
